:host {
  > ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      display: inline-block;
    }
  }
}

.separator {
  &::before {
    display: inline;
    content: ',\00a0';
  }
}
